import { createApp } from 'vue';
import { createPinia } from 'pinia';

import VueConfetti from 'vue-confetti';

import apiPlugin from './api';
import eventBus from '@/eventBus.js';
import translate from '@/plugins/translate.js';
import { registerGlobalComponents } from '@/global-components.js';
import { initSentry, createSentryPiniaPlugin } from '@/plugins/sentry.js';

const app = createApp({});

initSentry(app);

window.eventBus = eventBus;

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

app.use(pinia);

app.use(apiPlugin);
app.use(translate);
app.use(VueConfetti);

registerGlobalComponents(app);

app.mount('#app');
